import React, { useState, useRef, useEffect } from 'react';
import styles from './CreateNews.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import locationIcon from '../../../../assets/Imagess/location.svg';
import DatePicker from 'react-datepicker';
import { useMutation } from 'react-query';
import axios from 'axios';
import {
  API_URL,
  quillFormats,
  quillModules,
  securityHeaders,
} from '../../../../Constants';
import moment from 'moment';
import { useFetchCategories } from '../../../../Hooks/Categories';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchEventById } from '../../../../Hooks/Events';
import { isEmpty, values } from 'lodash';
import eventUpdated from '../../../../assets/Imagess/event-updated.png';
import './Quill.css';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextInput from '../../../Atoms/Inputs/TextInput';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import Loader from '../../../Molecules/Loader/Loader';
import he from 'he';
import { sanitizeAndValidateUrl } from '../../../../app/helpers/sanitizeAndValidateUrl';
import TextEditor from '../../../Molecules/Email/TextEditor';
import DateInput from '../../../Atoms/Inputs/DateInput';

const UpdateEvent = () => {
  const params = useParams();
  const { id } = params;
  const customizedToast = useToast();
  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const formikRef = useRef(null);
  const [showCheckmark, setShowCheckmark] = useState(false);

  const navigate = useNavigate();
  const [imageSrc1, setImageSrc1] = useState('');
  const [imageSrc2, setImageSrc2] = useState('');
  const [imageSrc3, setImageSrc3] = useState('');
  const { data: categories } = useFetchCategories();
  const {
    data: event,
    refetch: refetchEvent,
    isLoading,
  } = useFetchEventById({ id });

  useEffect(() => {
    if (!isEmpty(id) && id !== undefined) {
      refetchEvent();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(event)) {
      const eventData = event.data;
      formikRef.current.setValues({
        nameAr: eventData.title_AR || '',
        category: eventData.categoryId || '',
        location: eventData.locationLink || '',
        eventDate: eventData.eventDate ? new Date(eventData.eventDate) : '',
        requirementsAr: he.decode(eventData.eventText_AR || ''),
        RegisterLink: eventData.registerLink || '',
      });
      setImageSrc1(
        sanitizeAndValidateUrl(`${event?.data?.url}${event?.data?.image1}`)
      );
      setImageSrc2(
        sanitizeAndValidateUrl(`${event?.data?.url}${event?.data?.image2}`)
      );
      setImageSrc3(
        sanitizeAndValidateUrl(`${event?.data?.url}${event?.data?.image3}`)
      );
    }
  }, [event]);

  const validationSchema = Yup.object().shape({
    nameAr: Yup.string().required('مطلوب تعبئته'),
    eventDate: Yup.date().required('مطلوب تعبئته'),
    category: Yup.string().required('مطلوب تعبئته'),
    requirementsAr: Yup.string().required('مطلوب تعبئته'),
    location: Yup.string().required('مطلوب تعبئته'),
    image1: Yup.mixed().test(
      'image1-required',
      'الصورة الأولى مطلوبة',
      (file) => {
        const hasExisting = !!imageSrc1;
        const hasNew = file instanceof File;
        return hasExisting || hasNew;
      }
    ),
    image2:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().notRequired(),
    image3:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().notRequired(),
    RegisterLink: Yup.string()
      .required('مطلوب')
      .test('is-valid-url', 'رابط غير صالح', (value) => {
        if (!value) return false;
        try {
          new URL(value.startsWith('http') ? value : `https://${value}`);
          return true;
        } catch (e) {
          return false;
        }
      }),
  });

  const createNews = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/News/Events`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: (data) => {
      customizedToast.open(id ? 'تم التحديث بنجاح' : 'تم الإنشاء بنجاح');
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(-1);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    formData.append('AcademicYearId', '');
    formData.append('Title_Ar', values.nameAr);
    formData.append(
      'EventDate',
      moment(values.eventDate).format('YYYY-MM-DD HH:mm:ss')
    );
    formData.append('EventText_AR', values.requirementsAr);
    formData.append('CategoryId', values.category);
    formData.append('LocationLink', values.location);
    formData.append('isVisible', true);
    formData.append('RegisterLink', values.RegisterLink);
    formData.append('isActive', true);

    if (undefined !== values.image1) {
      formData.append('Image1', values.image1);
    }
    if (undefined !== values.image2) {
      formData.append('Image2', values.image2);
    }
    if (undefined !== values.image3) {
      formData.append('Image3', values.image3);
    }
    const eventId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('EventId', eventId);
    createNews.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={isEmpty(id) ? 'إنشاء فعالية' : 'تعديل فعالية'}
        />
      </div>{' '}
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            nameAr: event?.data.title_AR || '',
            category: event?.data.categoryId || '',
            location: event?.data.locationLink || '',
            eventDate: event?.data.eventDate
              ? new Date(event?.data.eventDate)
              : '',
            requirementsAr: he.decode(event?.data.eventText_AR || ''),
            image1: undefined,
            image2: undefined,
            image3: undefined,
            RegisterLink: event?.data.RegisterLink || '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <div className={styles['event-steps']}>
                <div
                  className={` ${styles['rtl']}`}
                  style={{ display: 'block' }}
                >
                  <TextInput
                    label='الاسم'
                    placeholder='أدخل الاسم'
                    icon={folderIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{ padding: '0px' }}
                    errors={errors.nameAr}
                    touched={touched.nameAr}
                    value={values.nameAr}
                    name='nameAr'
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                </div>
                <CustomSelect
                  label='اسم الفئة'
                  placeholder='أدخل الفئة'
                  icon={folderIcon}
                  style={{ width: '100%' }}
                  iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                  dropdownStyle={{ marginTop: '4px' }}
                  value={values.category}
                  name='category'
                  onChange={(name, e) => {
                    setFieldValue(name, e);
                  }}
                  options={categories?.data?.map((option) => ({
                    value: option.newsCategoryId,
                    text: option.category_AR,
                  }))}
                  touched={touched.category}
                  errors={errors.category}
                  type='category'
                  right
                />
                <DateInput
                  label='التاريخ'
                  placeholder='اختر التاريخ'
                  showIcon
                  value={values.eventDate}
                  name='eventDate'
                  onChange={setFieldValue}
                  dateFormat='yyyy-MM-dd HH:mm'
                  timeFormat='HH:mm'
                  timeInputLabel='الوقت:'
                  showTimeSelect
                  timeIntervals={30}
                  errors={errors.eventDate}
                  touched={touched.eventDate}
                />
                <TextInput
                  label='الموقع'
                  placeholder='أدخل الموقع'
                  icon={locationIcon}
                  style={{
                    width: '100%',
                    justifyContent: 'flex-start',
                  }}
                  containerStyle={{ padding: '0px' }}
                  errors={errors.location}
                  touched={touched.location}
                  value={values.location}
                  name='location'
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                />{' '}
              </div>
              <div className={styles['event-steps']}>
                <TextInput
                  label='رابط التسجيل'
                  placeholder='أدخل رابط التسجيل'
                  icon={folderIcon}
                  style={{
                    width: '100%',
                    justifyContent: 'flex-start',
                  }}
                  containerStyle={{ padding: '0px' }}
                  errors={errors.RegisterLink}
                  touched={touched.RegisterLink}
                  value={values.RegisterLink}
                  name='RegisterLink'
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                />
              </div>
              <div>
                <div className={`${styles['quill-container']}`}>
                  <TextEditor
                    label='تفاصيل الفعالية'
                    value={values.requirementsAr}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                    modules={quillModules}
                    formats={quillFormats}
                    name='requirementsAr'
                    placeholder='ادخل التفاصيل'
                    errors={errors.requirementsAr}
                    touched={touched.requirementsAr}
                    right
                  />
                </div>
              </div>

              <label className={styles['quill-label']}>تحميل الصورة</label>
              {errors.image1 && touched.image1 && (
                <div className={styles['error-message']}>
                  <p dir='rtl'>{errors.image1}</p>
                </div>
              )}

              <div
                className={styles['upload-container']}
                onClick={() => {
                  if (fileInputRef.current) fileInputRef.current.value = '';
                  fileInputRef.current.click();
                }}
              >
                <input
                  type='file'
                  accept='image/*'
                  className='form-control form-body-input'
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={(event) =>
                    setFieldValue('image1', event.currentTarget.files[0])
                  }
                />
                {values.image1 || imageSrc1 ? (
                  <div className={styles['image-container']}>
                    <img
                      className={styles['uploaded-image']}
                      src={
                        values.image1
                          ? URL.createObjectURL(values.image1)
                          : imageSrc1
                      }
                      alt='selected-image'
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = noImageFound;
                      }}
                    />
                    <button
                      className='delete-button-images'
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setFieldValue('image1', undefined);
                        setImageSrc1('');
                      }}
                      title='حذف الصورة'
                      type='button'
                    >
                      ✕
                    </button>
                  </div>
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        اختر صورة للتحميل
                      </p>
                      <p className={styles['size']}>
                        {' '}
                        الحد الأقصى للحجم: <span dir='ltr'>100 MB</span>{' '}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div
                className={styles['upload-container']}
                onClick={() => {
                  if (fileInputRef2.current) fileInputRef2.current.value = '';
                  fileInputRef2.current.click();
                }}
              >
                <input
                  type='file'
                  className='form-control form-body-input'
                  accept='image/*'
                  style={{ display: 'none' }}
                  ref={fileInputRef2}
                  onChange={(event) =>
                    setFieldValue('image2', event.currentTarget.files[0])
                  }
                />
                {values.image2 || imageSrc2 ? (
                  <div className={styles['image-container']}>
                    <img
                      className={styles['uploaded-image']}
                      src={
                        values.image2
                          ? URL.createObjectURL(values.image2)
                          : imageSrc2
                      }
                      alt='selected-image'
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = noImageFound;
                      }}
                    />
                    <button
                      className='delete-button-images'
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setFieldValue('image2', null);
                        setImageSrc2('');
                      }}
                      title='حذف الصورة'
                      type='button'
                    >
                      ✕
                    </button>
                  </div>
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        اختر صورة للتحميل
                      </p>
                      <p className={styles['size']}>
                        {' '}
                        الحد الأقصى للحجم: <span dir='ltr'>100 MB</span>{' '}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div
                className={styles['upload-container']}
                onClick={() => {
                  if (fileInputRef3.current) fileInputRef3.current.value = '';
                  fileInputRef3.current.click();
                }}
              >
                <input
                  type='file'
                  accept='image/*'
                  className='form-control form-body-input'
                  style={{ display: 'none' }}
                  ref={fileInputRef3}
                  onChange={(event) =>
                    setFieldValue('image3', event.currentTarget.files[0])
                  }
                />
                {values.image3 || imageSrc3 ? (
                  <div className={styles['image-container']}>
                    <img
                      className={styles['uploaded-image']}
                      src={
                        values.image3
                          ? URL.createObjectURL(values.image3)
                          : imageSrc3
                      }
                      alt='selected-image'
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = noImageFound;
                      }}
                    />
                    <button
                      className='delete-button-images'
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setFieldValue('image3', null);
                        setImageSrc3(''); // تأكد من مسح imageSrc3 أيضًا
                      }}
                      title='حذف الصورة'
                      type='button'
                    >
                      ✕
                    </button>
                  </div>
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        اختر صورة للتحميل
                      </p>
                      <p className={styles['size']}>
                        {' '}
                        الحد الأقصى للحجم: <span dir='ltr'>100 MB</span>{' '}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <button
                type='submit'
                className={styles['submit-button']}
                style={{ display: 'none' }}
              >
                إرسال
              </button>
            </Form>
          )}
        </Formik>
      </div>
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={eventUpdated} />
        </div>
      )}
    </div>
  );
};

export default UpdateEvent;
